export const ERROR_BOUNDARY_DISPLAYED = 'ERROR_BOUNDARY_DISPLAYED';
